import { render, staticRenderFns } from "./ReportsManagement.vue?vue&type=template&id=4a3497b2"
import script from "./ReportsManagement.vue?vue&type=script&lang=js"
export * from "./ReportsManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports